import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "px-4" }
const _hoisted_2 = { style: {"line-height":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Tree = _resolveComponent("Tree", true)!

  return (_openBlock(), _createBlock("ul", _hoisted_1, [
    (!_ctx.geoAddress.isHidden)
      ? (_openBlock(), _createBlock("li", {
          key: _ctx.geoAddress.name,
          class: [
        `flex px-2 py-2 items-center select-none gap-4`,
        {
          'cursor-pointer': !!_ctx.geoAddress.children.length && !_ctx.geoAddress.isDisabled,
        },
      ],
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openTree && _ctx.openTree(...args)))
        }, [
          _createVNode(_component_Icons, {
            name: "chevron-right-thin",
            style: {"width":"6px"},
            class: ["text-gray-lp-600 transform", [
          {'rotate-90': !_ctx.isOpen},
          {'-rotate-90': _ctx.isOpen},
          {'invisible': !_ctx.geoAddress.children.length}
        ]]
          }, null, 8, ["class"]),
          _createVNode(_component_Checkbox, {
            disabled: _ctx.geoAddress.isDisabled,
            binary: true,
            modelValue: _ctx.geoAddress.isChecked(_ctx.modelValue),
            onClick: _cache[1] || (_cache[1] = (e) => _ctx.onCheck(e, _ctx.geoAddress))
          }, null, 8, ["disabled", "modelValue"]),
          _createVNode("div", _hoisted_2, _toDisplayString(_ctx.geoAddress.name), 1)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.isOpen)
      ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.geoAddress.children, (child) => {
          return (_openBlock(), _createBlock(_component_Tree, {
            class: "pl-7",
            key: child.name,
            geoAddress: child,
            modelValue: _ctx.modelValue
          }, null, 8, ["geoAddress", "modelValue"]))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}